// src/components/Diameters.jsx
import React, { useEffect, useState } from 'react';
import { FaPlus, FaTrashAlt } from 'react-icons/fa';
import {
  fetchDiameters,
  createDiameter,
  deleteDiameter
} from '../../data/fetchData';


const Diameters = () => {
  const [loading, setLoading] = useState(true);
  const [diameters, setDiameters] = useState([]);
  const [newDiameter, setNewDiameter] = useState('');

  useEffect(() => {
    fetchDiameters()
      .then(list => setDiameters(list))
      .catch(err => console.error('Error fetching diameters:', err))
      .finally(() => setLoading(false));
  }, []);

  const handleAddDiameter = () => {
    // Valideerime, et väärtus ei ole tühi
    if (!newDiameter || newDiameter.trim() === '') {
      return;
    }
    
    createDiameter(newDiameter.trim())
      .then(d => {
        setDiameters(prev => [...prev, d]);
        setNewDiameter('');
      })
      .catch(err => console.error('Error creating diameter:', err));
  };

  const handleDeleteDiameter = (id) => {
    deleteDiameter(id)
      .then(() => {
        setDiameters(prev => prev.filter(d => d.id !== id));
      })
      .catch(err => console.error('Error deleting diameter:', err));
  };

  if (loading) return <p>Loading…</p>;

  return (
    <div className="p-4">
      <div className="flex mb-4">
        <input
          type="text"
          value={newDiameter}
          onChange={e => setNewDiameter(e.target.value)}
          placeholder="Lisa uus läbimõõt"
          className="flex-grow p-2 border border-gray-300 rounded-md mr-2"
        />
        <button
          onClick={handleAddDiameter}
          className="p-2 bg-primary text-white rounded-md hover:bg-primary-hover"
        >
          <FaPlus />
        </button>
      </div>
      <ul className="space-y-2">
        {diameters.map(d => (
          <li
            key={d.id}
            className="flex justify-between items-center p-2 border border-gray-300 rounded-md"
          >
            <span className="truncate w-3/4">{d.diameter}</span>
            <button
              onClick={() => handleDeleteDiameter(d.id)}
              className="text-red-500 hover:text-red-700"
            >
              <FaTrashAlt />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Diameters;
